import { render, staticRenderFns } from "./basicarchivesmanagement.vue?vue&type=template&id=4ea82701&scoped=true&"
import script from "./basicarchivesmanagement.vue?vue&type=script&lang=js&"
export * from "./basicarchivesmanagement.vue?vue&type=script&lang=js&"
import style0 from "./basicarchivesmanagement.vue?vue&type=style&index=0&id=4ea82701&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea82701",
  null
  
)

export default component.exports